<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">

        <div class="row mb-4">
            <div class="col-12">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">Configurações de Suprimentos</h1>
                        <p class="welcome-message">Aqui você encontra todas as configurações do seu módulo de suprimentos.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row search-area">
            <div class="col-12 col-md-6">
                <mat-form-field appearance="outline">
                    <mat-label>Pesquisar</mat-label>
                    <input matInput placeholder="Busque pela funcionalidade" [formControl]="pesquisaControl"
                        (keyup.enter)="filtrar()">

                    <button mat-icon-button matSuffix aria-label="Pesquisar" (click)="filtrar()">
                        <mat-icon>search</mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </div>

        @if (filteredMenuGroups.length === 0) {
            <app-empty-list [title]="'Nenhuma configuração encontrada'"
                [subTitle]="'Tente alterar os termos da busca'"></app-empty-list>
        } @else {
            @for (group of filteredMenuGroups; track group.title) {
                <div class="categoria-section">
                    <span class="categoria-titulo">{{ group.title }}</span>
                    <div class="configuracoes-list">
                        @for (item of group.items; track item.label) {
                            <button class="configuracao-item" [routerLink]="[item.route]">
                                <div class="configuracao-left">
                                    <mat-icon class="material-symbols-outlined configuracao-icon">{{ item.icon }}</mat-icon>
                                    <span class="configuracao-nome">{{ item.label }}</span>
                                </div>
                                <mat-icon class="configuracao-chevron">chevron_right</mat-icon>
                            </button>
                        }
                    </div>
                </div>
            }
        }
    </div>
</div>
